import { render, staticRenderFns } from "./SectionResolution.vue?vue&type=template&id=69712217&scoped=true&"
import script from "./SectionResolution.vue?vue&type=script&lang=js&"
export * from "./SectionResolution.vue?vue&type=script&lang=js&"
import style0 from "./SectionResolution.vue?vue&type=style&index=0&id=69712217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69712217",
  null
  
)

export default component.exports